import { motion } from "framer-motion";
import { ShieldCheck, TrendingUp, Landmark, GraduationCap } from "lucide-react";

const cards = [
  {
    icon: ShieldCheck,
    title: "Protección familiar completa",
    desc: "Si algo te pasa, tu familia recibe un beneficio por fallecimiento libre de impuestos para seguir adelante sin deudas ni preocupaciones.",
    tone: "text-brand-blue bg-blue-50",
  },
  {
    icon: TrendingUp,
    title: "Crece sin riesgo de mercado",
    desc: "Tu valor en efectivo gana intereses cuando el índice sube y tiene un piso garantizado del 0% cuando baja. Nunca pierdes por el mercado.",
    tone: "text-growth bg-[var(--green-50)]",
  },
  {
    icon: Landmark,
    title: "Efectivo libre de impuestos",
    desc: "Accede a tu dinero acumulado mediante préstamos o retiros libres de impuestos para emergencias, negocios o lo que necesites.",
    tone: "text-amber-600 bg-amber-50",
  },
  {
    icon: GraduationCap,
    title: "Retiro y legado dignos",
    desc: "Construye un ingreso complementario para tu jubilación y deja un legado sólido para la universidad o el futuro de tus hijos.",
    tone: "text-navy bg-slate-100",
  },
];

export const Benefits = () => (
  <section id="beneficios" className="py-20 lg:py-28 bg-white scroll-mt-20" data-testid="benefits-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="max-w-2xl">
        <p className="text-xs font-bold tracking-[0.2em] text-growth uppercase">Por qué un IUL</p>
        <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-navy">
          Miles de familias hispanas ya eligieron proteger y crecer al mismo tiempo.
        </h2>
        <p className="mt-4 text-base md:text-lg text-slate-600">
          Un solo plan que cuida a los tuyos hoy y construye tu patrimonio para mañana.
        </p>
      </div>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map(({ icon: Icon, title, desc, tone }, i) => (
          <motion.article
            key={title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.55, delay: i * 0.1 }}
            className="card-lift rounded-2xl border border-slate-200 bg-white p-6"
            data-testid={`benefit-card-${i + 1}`}
          >
            <span className={`grid place-items-center h-12 w-12 rounded-xl ${tone}`}>
              <Icon className="h-6 w-6" />
            </span>
            <h3 className="mt-5 text-lg font-bold text-navy leading-snug">{title}</h3>
            <p className="mt-2 text-sm text-slate-600 leading-relaxed">{desc}</p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
